import React, { Component } from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _actions from '../../actions';
import ValidatedInput from '../forms/ValidatedInput';
import AlignLeft from '../svg/AlignLeft';
import AlignCenter from '../svg/AlignCenter';
import AlignRight from '../svg/AlignRight';
import OnOffSwitch from '../forms/OnOffSwitch';
import TapTypeSelector from './TapTypeSelector';

class LinkButtonContentEditor extends Component {
    render() {
        return (
            <div className="edit-link-content">
                <span className="preview">Preview</span>
                <div className="preview-block-text">
                    {/* eslint-disable */}
                    {this.props.contentModalContent.appearanceType === 1 &&
                    <p style={{ color: this.props.versions.select.actionColor, textAlign: this.props.contentModalContent.contentAlign === 1 ? 'left' : this.props.contentModalContent.contentAlign === 2 ? 'center' : 'right' }}>
                        {this.props.contentModalContent.text !== '' ? this.props.contentModalContent.text : 'Link Text'}
                    </p>
                    }
                    {this.props.contentModalContent.appearanceType === 2 &&
                    <button className='btn btn-primary btn-sm'>{this.props.contentModalContent.text !== '' ? this.props.contentModalContent.text : 'Button Text'}</button>
                    }
                    {/* eslint-enable */}
                </div>
                {this.props.contentModalContent.appearanceType === 1
                    && (
                        <div className="content-alignment">
                            <button data-qa="content-alignment-left-button" type="button" className={`btn-design-system medium secondary icon ${this.props.contentModalContent.contentAlign === 1 ? 'active' : ''}`} onClick={() => { this.props.changeAlignment(1); }}>
                                <AlignLeft />
                            </button>
                            <button data-qa="content-alignment-center-button" type="button" className={`btn-design-system medium secondary icon ${this.props.contentModalContent.contentAlign === 2 ? 'active' : ''}`} onClick={() => { this.props.changeAlignment(2); }}>
                                <AlignCenter />
                            </button>
                            <button data-qa="content-alignment-right-button" type="button" className={`btn-design-system medium secondary icon ${this.props.contentModalContent.contentAlign === 3 ? 'active' : ''}`} onClick={() => { this.props.changeAlignment(3); }}>
                                <AlignRight />
                            </button>
                        </div>
                    )}
                <div className="type-toggle">
                    <OnOffSwitch
                        id="link-button-switch"
                        buttonClass="toggle checkbox md-checkbox"
                        isToggleOn={this.props.contentModalContent.appearanceType === 2}
                        name="enabled"
                        onChange={(e) => {
                            const check = e.target.checked ? 2 : 1;
                            this.props.setStateFromEvent(check, 'appearanceType');
                        }}
                        dataQA="link-button-switch"
                    />
                    {' '}
                    Use a button style
                </div>
                <div className="text-input-wrapper">
                    <ValidatedInput
                        containerClass="input_Text"
                        labelText={this.props.contentModalContent.appearanceType === 2 ? 'Button Text' : 'Link Text'}
                        value={this.props.contentModalContent.text}
                        name="text"
                        onChange={(e) => { return this.props.setStateFromEvent(e, 'text'); }}
                        errorMessage=""
                        hasError={false}
                        successMessage=""
                        hasSuccess={false}
                    />
                </div>

                <TapTypeSelector updateTapTypeFromEvent={this.props.updateTapTypeFromEvent} contentModalContent={this.props.contentModalContent} formsObjects={this.props.formsObjects} formsItems={this.props.formsItems} pagesItems={this.props.pagesItems} setStateFromEvent={this.props.setStateFromEvent} />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(LinkButtonContentEditor);
